export default {"src":"/_next/static/media/PEP.3e36a023.svg","height":18,"width":18};